import type { NskResponse } from '~/models/Api';
import { postRequest, putRequest } from '../api_handler';
import { generatePath } from '~/utils/generatePath';

export const create = async (email: string): Promise<NskResponse<void>> =>
  postRequest(generatePath('/vendors/vendor_company_password_resets'), {
    email
  });

export const update = async (
  token: string,
  password: string
): Promise<NskResponse<void>> =>
  putRequest(generatePath('/vendors/vendor_company_password_resets'), {
    token,
    password
  });
